export const isMultiColor = (color: string): boolean => {
  return color.toLowerCase() === 'multi';
};
